import { IGetItemsParams } from '../types/IGetItemsParams';
import { IGetItemsResult } from '../types/IGetItemsResult';
import { IConnectedView, IMetric } from '../types/IMetric';
import { IMetricUsageInfo } from '../types/IUsageInfo';
import { IUser } from '../types/IUser';
import { INamedItem } from '../types/resourceParts';
import { Request } from './Request';

export interface IGetMetricsParams extends IGetItemsParams {
}

export interface IGetMetricsResult extends IGetItemsResult {
  metrics?: IMetric[];
  users?: IUser[];
  connectedViews: IConnectedView[];
  projects?: INamedItem[];
  favorites?: string[];
  maxStats?: IMetricUsageInfo;
}

export class GetMetricsRequest extends Request<IGetMetricsParams, IGetMetricsResult> {
  constructor(params: IGetMetricsParams) {
    super('getMetrics', params);
  }
}
